"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var BaseApi_1 = require("./BaseApi");
var config_1 = require("../config");
var BaseApi = (_a = {},
    _a[config_1.Environments.PRODUCTION] = BaseApi_1.ProdApi,
    _a[config_1.Environments.STAGE] = BaseApi_1.StageApi,
    _a[config_1.Environments.LOCAL] = BaseApi_1.LocalApi,
    _a);
function Auth(env, customApiUrl) {
    if (env === void 0) { env = config_1.Environments.PRODUCTION; }
    if (env === 'TEST') {
        env = config_1.Environments.STAGE;
    }
    var API = customApiUrl ? BaseApi_1.CustomApi(customApiUrl) : BaseApi[env];
    return ({
        postRegistrations: function (data) { return API.post('/users/registrations', data); },
        putRegistrations: function (user, token, email) { return API.put('/users/registrations', user, {
            headers: {
                'X-User-Token': token,
                'X-User-Email': email,
            }
        }); },
        getConfirmations: function (token) { return API.get("/users/confirmations?confirmation_token=" + token); },
        postConfirmations: function (email) { return API.post('/users/confirmations', email); },
        postUnlockAccount: function (email) { return API.post('/users/unlock_accounts', email); },
        postSessions: function (data) { return API.post('/users/sessions', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }); },
        deleteSessions: function (token, email) { return API.delete('/users/sessions', {
            headers: {
                'X-User-Token': token,
                'X-User-Email': email,
            }
        }); },
        postPasswords: function (user) { return API.post('/users/passwords', user); },
        putPasswords: function (reset_password_token, password, password_confirmation) { return API.put('/users/passwords', {
            user: {
                reset_password_token: reset_password_token,
                password: password,
                password_confirmation: password_confirmation,
            }
        }); },
        omniAuths: function (provider, access_token) { return API.post("/users/auth/" + provider + "/callback?access_token=" + access_token, null, {
            baseURL: config_1.CLASSROOMS_API_WO_VERSION[env],
        }); },
        putUserData: function (id, data, token, email) { return API.put("/users/" + id, data, {
            headers: {
                'X-User-Token': token,
                'X-User-Email': email,
            }
        }); },
        getUser: function (token, email) { return API.get('/users', {
            headers: {
                'X-User-Token': token,
                'X-User-Email': email,
            }
        }); },
        putUser: function (data, token, email) { return API.put('/users', data, {
            headers: {
                'X-User-Token': token,
                'X-User-Email': email,
            }
        }); },
        postRegisterBetaUser: function (data) { return API.post("/beta_users", data, {
            baseURL: config_1.CLASSROOMS_API_WO_VERSION[env],
        }); },
    });
}
exports.default = Auth;
//# sourceMappingURL=auth.js.map